import {
  AusFlagIcon,
  BrazilFlagIcon,
  CanadaFlagIcon,
  EuroFlagIcon,
  IndiaFlagIcon,
  JapanFlagIcon,
  KoreaFlagIcon,
  MexicoFlagIcon,
  SingaporeFlagIcon,
  UaeFlagIcon,
  UkFlagIcon,
  UsaFlagIcon,
} from '@/assets'
import { CURRENCIES } from '@/utils'

export const currencies = [
  { value: CURRENCIES.USD, flag: UsaFlagIcon },
  { value: CURRENCIES.CAD, flag: CanadaFlagIcon },
  { value: CURRENCIES.EUR, flag: EuroFlagIcon },
  { value: CURRENCIES.GBP, flag: UkFlagIcon },
  { value: CURRENCIES.MXN, flag: MexicoFlagIcon },
  { value: CURRENCIES.AUD, flag: AusFlagIcon },
  { value: CURRENCIES.JPY, flag: JapanFlagIcon },
  { value: CURRENCIES.BRL, flag: BrazilFlagIcon },
  { value: CURRENCIES.INR, flag: IndiaFlagIcon },
  { value: CURRENCIES.KRW, flag: KoreaFlagIcon },
  { value: CURRENCIES.AED, flag: UaeFlagIcon },
  { value: CURRENCIES.SGD, flag: SingaporeFlagIcon },
]

export type CurrencyOption = (typeof currencies)[number]
